module.exports = __webpack_public_path__ + "static/img/storywalk-frames-and-posts.e831fa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/products/storywalk-frames-and-posts.jpg
// module id = 427
// module chunks = 0